<template>
  <div class="nav308">
    <div id="mySidenav" ref="sidenav" class="sidenav ">
      <span class="closebtn" @click="closeNav()">
        <i class="bi bi-x"></i>
      </span>
      <div class="text-center">
        <img class="mx-auto nav308-inside-logo" :src="findAttributeOnSiteInfo('icon')[0]"
             :alt="findAttributeOnSiteInfo('site_name')[0]">
      </div>
      <m-base-menu class="nav308-menu text-center" :menu-position="menuPosition"/>

      <div class="text-center mx-auto">
        <m-search-input1 class="nav308-search  nav308-search-side"/>
      </div>

    </div>

    <div class="row justify-content-center align-items-center m-0">

      <div class="col-6 col-lg-4 col-sm-4 col-md-4 nav308-toggle-button d-inline-block">
      <span @click="openNav()" class="d-inline-block h5"><i class="bi bi-list"></i><span
          v-t="`nav.menu_name`"></span></span>
      </div>

      <div class="col-6 col-lg-4 col-sm-4 col-md-4 nav308-logo-parent text-right">
        <img class="img-fluid nav308-logo" :src="findAttributeOnSiteInfo('icon')[0]"
             :alt="findAttributeOnSiteInfo('site_name')[0]">
      </div>

      <div class="d-none d-md-block co-lg-4 co-lg-4 d-none nav308-search text-center">
        <m-search-input1 class="d-inline-block"/>
      </div>
    </div>
  </div>

</template>

<script>
import mBaseMenu from "../../Menu/BaseMenu.vue";
import {MenuProps} from "../../Menu/MenuProps";
import mSearchInput1 from "../../Search/Input/SearchInput1.vue";

export default {
  name: "Nav308",
  components: {mSearchInput1, mBaseMenu},
  props: {
    ...MenuProps
  },
  data() {
    return {
      body: null,
      screenSize: window.innerWidth,
      mobileScreen: 712
    }
  },
  computed: {
    isDesktopScreen() {
      return this.screenSize >= this.mobileScreen;
    }
  },
  methods: {
    openNav() {
      const mySidenav = this.$refs.sidenav
      mySidenav.style.width = "250px";
      if (this.isDesktopScreen) { // if not in mobile
        this.body.style.transition = 'margin-left .5s'
        this.body.style.marginRight = "250px";
      }
    },
    closeNav() {
      const mySidenav = this.$refs.sidenav
      mySidenav.style.width = "0";
      this.body.style.marginRight = "0";
    }
  },
  beforeMount() {
    this.body = document.querySelector("body")
  },
  mounted() {
    if (this.isDesktopScreen) {
      this.openNav()
    }
  }
}
</script>


<style scoped>
.nav308 {
  background: var(--primary);
  padding: 10px;
}

.sidenav {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 1;
  top: 0;
  right: 0;
  background-color: var(--dark);
  overflow-x: hidden;
  transition: 0.5s;
  padding-top: 60px;
}

.sidenav :deep(.base-menu-item-icon) {
  display: inline-block !important;
  margin: 0 7px;
}

.sidenav :deep(.base-menu-item-wrapper) {
  padding: 8px 8px 8px 32px;
  text-decoration: none;
  font-size: 20px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.sidenav :deep(.base-menu-item-wrapper):hover {
  color: #f1f1f1;
}

.sidenav .closebtn {
  position: absolute;
  color: var(--white);
  top: 0;
  right: 25px;
  font-size: 36px;
  margin-left: 50px;
}

.nav308-logo, .nav308-inside-logo {
  width: 105px;
  height: 105px;
}

.nav308-search :deep(form), .nav308-search :deep(input) {
  border-radius: 9px;
}

.nav308-search-side {
  position: absolute;
  bottom: 18px;
  right: 15px;
}

</style>